import Phaser from 'phaser';

export default class Boot extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    // Start Preload directly; Preload will hand off to Level.
    this.scene.start('Preload');
  }
}
